import { createActions } from 'reduxsauce'

const { Types: SolanaNFTTypes, Creators: SolanaNFTActions } = createActions({
  resetSolanaNFTData: null,
  getSolanaNFTData: ['loading'],
  setSolanaNFTData: ['collection', 'limit', 'hasDataToLoad'],
  updateSolanaNFTCollection: ['slug', 'collection'],
  deleteSolanaNFTCollection: ['id'],
})

export { SolanaNFTTypes, SolanaNFTActions }
